import { render, staticRenderFns } from "./GptSetting.vue?vue&type=template&id=623232a5"
import script from "./GptSetting.vue?vue&type=script&lang=js"
export * from "./GptSetting.vue?vue&type=script&lang=js"
import style0 from "./GptSetting.vue?vue&type=style&index=0&id=623232a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports